import { useEffect, useState } from "react";
import style from "./index.module.scss";
import UKDialog from "@/components/UKDialog";
import { DialogTitle, DialogContent } from "@mui/material";
import { GetReserves } from "@/apis/reservation/reservation.api";
import JDIPrice from "@/common-components-src/js/price/index";
import UKPageNothing from "@/components/UKPageNothing";
import Countdown from "@/components/reservationDialog/countdown/countdown";
import CDNImage from "../cdnImage/cdnImage";
import { useTranslation } from "@/i18n/client";
import { EXPOSURE_RECORD } from '@/tracks/25208'

type Props = {
  open: boolean;
  closeFn: any;
  reserveTotal: number;
  currencySymbol: string;
};
const DialogStyle = {
  "& .MuiDialog-paper": {
    width: "520px",
    margin: "0",
    borderRadius: "12px",
  },
  "& .MuiDialogTitle-root": {
    fontSize: "16px",
    fontWeight: "bold",
    lineHeight: "20px",
    padding: "20px 24px",
  },
  "& .MuiDialogContent-root": {
    maxHeight: "560px",
    paddingTop: "0px",
  },
};
const ReservationDialog = ({ open, closeFn, reserveTotal = 0, currencySymbol }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [reservationList, setReservationList] = useState<any>([]);
  const { t } = useTranslation();
  useEffect(() => {
    setIsOpen(open);
    if (open) {
      getReserves();
    }
  }, [open]);

  const closeHandler = () => {
    setIsOpen(false);
    closeFn && closeFn();
  };
  const getReserves = async () => {
    const res = await GetReserves(5);
    setReservationList(res || []);
  };

  const onCountdownEnd = () => {
    getReserves()
  }

  const trackParams = (index: number, item: any, groupId: string) => {
    return {
      skuid: item?.skuId,
      firprice: item?.originalPrice,
      firpricetype: "52",
      index,
      floorid:groupId
    };
  };

  //关闭模态框
  return (
    <UKDialog open={isOpen} onClose={closeHandler} showCloseBtn={true} sx={DialogStyle}>
      <DialogTitle>
        {reserveTotal ? `${reserveTotal > 1 ? t("flashSales.myReservations") : t("flashSales.myReservation")}(${reserveTotal})` : t("flashSales.myReservation")}
      </DialogTitle>
      <DialogContent>
        <div className={style.reservationModel}>
          {reservationList.length > 0 ? (
            <div className={style.reservatonProducts}>
              {reservationList.map((group: any, index:number) => {
                return (
                  <div 
                        className={style.group} 
                        key={group.groupId}
                      >
                    <div className={style.countdown}>
                      <div className={style.pinkDot}></div>
                      {group.isCountDown ? (
                        <Countdown remainBeginTimes={group.remainBeginTimes * 1000} onCountdownEnd={onCountdownEnd} />
                      ) : (
                        <span className={style.batchName}>{group.batchName}</span>
                      )}
                    </div>
                    {group?.skus &&
                      group.skus.length > 0 &&
                      group.skus.map((item: any) => {
                        return (
                          <div 
                                className={style.product}
                                key={item.skuId}
                                exptag={"exp|" + EXPOSURE_RECORD.Activity_FlashSales_MyReserve}
                                data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
                                data-exptag-json-param={JSON.stringify(trackParams(index, item, group.groupId))}
                              >
                            <div className={style.left}>
                              <CDNImage src={item.skuImg} width={120} height={120} alt={item.skuName}></CDNImage>
                            </div>
                            <div className={style.right}>
                              <div className={style.skuName}>{item.skuName}</div>
                              <JDIPrice
                                symbol={currencySymbol}
                                price={item.realPrice}
                                containerStyle={{ lineHeight: "18px" }}
                                integerStyle={{ fontSize: "18px" }}
                                decimalPointStyle={{ fontSize: "16px" }}
                                decimalPlaceStyle={{ fontSize: "16px" }}
                                uiType={1}
                              />
                            </div>
                          </div>
                        );
                      })}
                  </div>
                );
              })}
            </div>
          ) : (
            <div 
                className={style.nothing}
                exptag={"exp|" + EXPOSURE_RECORD.Activity_FlashSales_MyReserve_Empty}
                data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
              >
              <UKPageNothing text={`${t("flashSales.empty")}`} />
            </div>
          )}
        </div>
      </DialogContent>
    </UKDialog>
  );
};

export default ReservationDialog;
